import { getDormantFeatures, productFeatureForPath } from "./dormantFeatures.js";

// Pure nav lists so they are easy to test.
export const PUBLIC_NAV_LINKS = [
  { to: "/about", label: "About" },
  { to: "/guides", label: "Guides" },
];

export const MEMBER_ONLY_NAV_PATHS = ["/dashboard", "/chat", "/dashboard/finances"];

// Members see Dashboard, Chat, and Money only when that feature flag is on.
// Non-members never see those items. Flags off hides them for everyone.
export function visibleAppNavItems(items, membershipActive, features = getDormantFeatures()) {
  return (items || []).filter((item) => {
    if (!membershipActive && MEMBER_ONLY_NAV_PATHS.includes(item.to)) return false;
    const feature = productFeatureForPath(item.to);
    if (feature && !features[feature]) return false;
    return true;
  });
}
